module.exports = __webpack_public_path__ + "static/media/Icon_3.0e20dea8.svg";